<template>
  <header id="header">
    <nav>
      <div class="logo">
        <a href="/" class="logo">
          <img src="../../assets/img/logo.png" alt="Acoperiș Expert" />
        </a>
      </div>
      <ul class="contact-info">
        <li>
          <a href="https://goo.gl/maps/NVJFWt2mepF2" target="_blank">
            <div class="icon">
              <font-awesome-icon icon="map-marker" class="fas"></font-awesome-icon>
            </div>
            <div class="contact-info__details">
              <span>Ne gasiti la</span>
              <span>Bistrita – Str. Calea Moldovei nr 17</span>
            </div>
          </a>
        </li>
        <li>
          <a href="tel:0754 094 617">
            <div class="icon">
              <font-awesome-icon icon="phone" class="fas"></font-awesome-icon>
            </div>
            <div class="contact-info__details">
              <span>Sunati-ne la</span>
              <span>0754 094 617</span>
            </div>
          </a>
        </li>
        <li>
          <a href="mailto:radudiafanis@gmail.com">
            <div class="icon">
              <font-awesome-icon icon="envelope" class="fas"></font-awesome-icon>
            </div>
            <div class="contact-info__details">
              <span>Trimiteti-ne un mesaj</span>
              <span>radudiafanis@gmail.com</span>
            </div>
          </a>
        </li>
        <li class="careers">
          <router-link class="btn btn-green" to="/cariere">Cariere</router-link>
        </li>
        <li class="contact">
          <button class="btn" @click="show()">Contact</button>
        </li>
      </ul>
    </nav>
  </header>
</template>

<script>
export default {
  data() {
    return {
      name: "Header"
    };
  },
  methods: {
    show() {
      this.$modal.show("contact-modal");
    },
    hide() {
      this.$modal.hide("contact-modal");
    }
  }
};
</script>

<style lang="scss">
</style>




// WEBPACK FOOTER //
// src/components/layouts/Header.vue